import React from "react";
import TablePagination from '@mui/material/TablePagination';
import Grid from '@mui/material/Grid';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import StdButton from './stdbutton.jsx';
import CsvDropzone from './csvdropzone.jsx';

class Checklist extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            versions: [],
            currentVersion: null,
            items: [],
            page: { rowsPerPage: 5 },
            dlgOpen: false
        };

        this.setState = this.setState.bind(this);
        this.loadData = this.loadData.bind(this);
        this.refresh = this.refresh.bind(this);
        this.onVersionsLoad = this.onVersionsLoad.bind(this);
        this.onVersionChange = this.onVersionChange.bind(this);
        this.loadChecklist = this.loadChecklist.bind(this);
        this.loadLatest = this.loadLatest.bind(this);
        this.onChecklistLoad = this.onChecklistLoad.bind(this);

        this.onChangePage = this.onChangePage.bind(this);
        this.onChangeRowsPerPage = this.onChangeRowsPerPage.bind(this);

        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);

    }

    componentDidMount() {
       this.loadData();
    }

    loadData(){
        getData("/web/checklists/versions/" + this.props.type, this.onVersionsLoad);
    }

    refresh(){
        this.setState({ dlgOpen: false, isLoaded: false });
        this.loadData();
    }

    onVersionsLoad(result){
        if (result.isLoaded) {
            if (result.items.length>0) {
                this.setState({ versions: result.items, currentVersion: result.items[0] });
                this.loadChecklist(result.items[0]);
            } else {
                this.setState({ versions: [], currentVersion: null, isLoaded: true });
            }

        } else {
            this.setState({ error: result.error });
        }
    }

    loadChecklist(version){
        getData("/web/checklists/" + version, this.onChecklistLoad);
    }

    onChecklistLoad(result){
        if (result.isLoaded) {
            this.setState({ items: result.items, isLoaded: true, page: { totalElements: result.items.length, rowsPerPage: 5, pageNumber: 0 } });
        } else {
            this.setState({ error: result.error });
        }
    }

    loadLatest(){
        var version = this.state.versions[0];
        this.setState({ currentVersion: version, isLoaded: false });
        this.loadChecklist(version);
    }

    onVersionChange(event){
        this.setState({ currentVersion: event.target.value, isLoaded: false });
        this.loadChecklist(event.target.value);
    }

    onChangePage(event, pageNum){
        var pageObj = this.state.page;
        pageObj.pageNumber=pageNum;
        this.setState({ page: pageObj });
    }

    onChangeRowsPerPage(event){
        var pageObj = this.state.page;
        pageObj.rowsPerPage=event.target['value'];
        pageObj.pageNumber=0;
        this.setState({ page: pageObj });
    }

    handleClose() {
        this.setState({
            dlgOpen: false
        });
    }



    handleOpen() {
        this.setState({
            dlgOpen: true,
        });
    }



    parseVersion(version){
        var result = version.substring(0,4) + "-" + version.substring(4,6) + "-" + version.substring(6,8) + "-" + version.substring(8,14);
        return result;
    }

    render() {
        const { error, isLoaded, items, page, versions } = this.state;

        if (error) {
            return <div style={{ background: '#ffffff', border: '2px solid #dfdfdf' }}>Error: {error.message}</div>;
        } else if (!isLoaded) {
            return <div className="text-center" style={{ background: '#ffffff', border: '2px solid #dfdfdf' }}><div className="spinner-border m-5" /></div>;
        } else {
            return (
                         <div style={{ background: '#ffffff', border: '2px solid #dfdfdf' }}>
                            <Grid container spacing={0}>
                                <Grid item xs={6} sm={6} style={{ padding: 20 }}>
                                    <h2>{this.props.title}</h2>
                                </Grid>
                                <Grid item xs={6} sm={6} style={{ padding: 20, textAlign: "right" }}>
                                    {(this.state.versions.length==0 || this.state.versions[0]==this.state.currentVersion) ? (
                                    <StdButton label="Upload New Version" icon="cloud_upload" onClick={this.handleOpen}/>
                                    ):(
                                    <StdButton label="See current version" onClick={this.loadLatest}/>
                                    )}
                                    <CsvDropzone open={this.state.dlgOpen} title={'Upload ' + this.props.title}
                                                 onClose={this.handleClose} onSuccess={this.refresh}
                                                 endpoint={'/web/checklists/upload/' + this.props.type}
                                                 columns={['title','group','description']} />
                                </Grid>
                            </Grid>
                             {items.length>0 ? (
                                 <div>
                                     <Table padding="dense">
                                         <TableHead>
                                             <TableRow>
                                                 <TableCell>Group</TableCell>
                                                 <TableCell>Title</TableCell>
                                                 <TableCell>Description</TableCell>
                                             </TableRow>
                                         </TableHead>
                                         <TableBody>
                                             {items.filter((item, index) => (index>=(page.pageNumber*page.rowsPerPage) && index<((page.pageNumber+1)*page.rowsPerPage))).map((item, index) => (
                                                 <TableRow key={index}>
                                                     <TableCell>{item.group}</TableCell>
                                                     <TableCell>{item.title}</TableCell>
                                                     <TableCell>{item.description}</TableCell>
                                                 </TableRow>
                                             ))}
                                         </TableBody>
                                     </Table>
                                     <Grid container spacing={0}>
                                         <Grid item xs={6} sm={6} style={{ display: 'flex' }}>
                                             <div style={{ height: 55, padding: 15 }}>Version:&nbsp;&nbsp;</div>
                                             <Select value={this.state.currentVersion} onChange={this.onVersionChange} disableUnderline={true}>
                                                 {versions.map(version => (
                                                        <MenuItem key={version} value={version}>{this.parseVersion(version)}</MenuItem>
                                                 ))}
                                             </Select>
                                         </Grid>
                                         <Grid item xs={6} sm={6}>
                                             <TablePagination
                                                 rowsPerPageOptions={[5, 10, 15]}
                                                 component="div"
                                                 count={this.state.page.totalElements}
                                                 rowsPerPage={this.state.page.rowsPerPage}
                                                 page={this.state.page.pageNumber}
                                                 backIconButtonProps={{
                                                     'aria-label': 'Previous Page',
                                                 }}
                                                 nextIconButtonProps={{
                                                     'aria-label': 'Next Page',
                                                 }}
                                                 onPageChange={this.onChangePage}
                                                 onRowsPerPageChange={this.onChangeRowsPerPage}
                                             />
                                         </Grid>
                                     </Grid>
                                 </div>
                             ):(
                                <div style={{ padding: 20 }}>No items found</div>
                                 )}

                        </div>
            )
        }
    }

}


export default Checklist;